enum PinataApiServer {
  DigitalOcean = 2,
  Localhost = 3,
}

export { PinataApiServer };
